const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

/**
 * Byte'ı uygun birime çevirir: B, KB, MB veya GB (2 ondalık).
 */
export function formatBytes(bytes: number): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes < 0) return '0 B';
  if (bytes < KB) return `${bytes} B`;
  if (bytes < MB) return `${(bytes / KB).toFixed(2)} KB`;
  if (bytes < GB) return `${(bytes / MB).toFixed(2)} MB`;
  return `${(bytes / GB).toFixed(2)} GB`;
}

/**
 * Byte cinsinden değeri GB'a çevirir (2 ondalık). Eski kullanım için.
 */
export function bytesToGb(bytes: number): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes < 0) return '0.00';
  return (bytes / GB).toFixed(2);
}
